/** Lightweight toast bus. */
type ToastKind = "info" | "success" | "warn" | "error";
interface Toast { id: number; kind: ToastKind; title: string; detail?: string; }

function createToasts() {
  let list = $state<Toast[]>([]);
  let nextId = 1;

  function push(kind: ToastKind, title: string, detail?: string, ttl = 4500) {
    const id = nextId++;
    list = [...list, { id, kind, title, detail }];
    setTimeout(() => dismiss(id), ttl);
  }

  function dismiss(id: number) {
    list = list.filter((t) => t.id !== id);
  }

  return {
    get list() { return list; },
    info: (t: string, d?: string) => push("info", t, d),
    success: (t: string, d?: string) => push("success", t, d),
    warn: (t: string, d?: string) => push("warn", t, d),
    error: (t: string, d?: string) => push("error", t, d, 7000),
    dismiss,
  };
}

export const toasts = createToasts();
